import { useState, useEffect } from "react";

/**
 * React hook to force a component re-render.
 * Exposes a function that toggles a boolean and returns it,
 * the change will force a React component to re-render
 */
export const useForceUpdate = () => {
	const [value, setValue] = useState(true);
	return () => setValue(!value);
};

/**
 * Returns a value after a set amount of time.
 * is used for stopping a value from being set until a user has stopped typing
 * @param value the value to be returned
 * @param delay	amount of time in milliseconds
 */
export const useDebounce = (value, delay) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [delay, value]);

	return debouncedValue;
};
